// Slim footer — version + build hash + a discreet pointer to the CLI.
// Always visible across viewport sizes; on mobile it doubles as the
// "I'm running build X" anchor that QA can quote in bug reports.

const builtAt = (() => {
  try {
    return new Date(__APP_BUILT_AT__).toISOString().slice(0, 10);
  } catch {
    return __APP_BUILT_AT__;
  }
})();

export function Footer(): JSX.Element {
  return (
    <footer className="app-footer" role="contentinfo">
      <span className="app-footer-brand">דילוגים · dilugim</span>
      <span className="app-footer-meta">
        <span className="app-footer-version" title={`commit ${__APP_COMMIT__}, built ${builtAt}`}>
          v{__APP_VERSION__}
        </span>
        <span className="app-footer-sep" aria-hidden>·</span>
        <span className="app-footer-built">{builtAt}</span>
      </span>
    </footer>
  );
}
